// Open Not Available Listener
document.querySelectorAll(".openNotAvailable").forEach(function (element) {
    element.addEventListener("click", () => {
        openNotAvailable();
    });
});

// Opens not available dialog
function openNotAvailable() {
    document.querySelector("#unavailable").showModal();
    document.querySelector("body").classList.add("noScroll");
}

// Closes not available dialog
document.querySelector("#unavailableBodyClose").addEventListener('click', function (event) {
    document.querySelector('#unavailable').close();
});


// when close event is triggered on modal
document.querySelector("#unavailable").addEventListener('close', function (event) {
    document.querySelector("body").classList.remove("noScroll");
});

// clicking backdrop closes
document.querySelector("#unavailable").addEventListener('click', function (event) {
    if (event.target === this) {
        document.querySelector('#unavailable').close()
    }
});

// submit form
document.querySelector("#unavailableBodyForm").addEventListener('submit', function (e) {
    e.preventDefault();

    // close
    document.querySelector('#unavailable').close();

    // identify
    klaviyo.identify({
        '$first_name': document.querySelector(`.unavailableBodyFormInput[name="first_name"]`).value,
        '$last_name': document.querySelector(`.unavailableBodyFormInput[name="last_name"]`).value,
        '$email': document.querySelector(`.unavailableBodyFormInput[name="email"]`).value,
        '$country': geoip.country_name
    }).then(() => {
        // track
        klaviyo.push(["track", "MalterTech | International Interest Form", {
            "$event_id": new Date().getTime(),
        }])

        // success
        Swal.fire({
            icon: 'success',
            text: "You've signed up successfully. We'll let you know when we're available in your country!",
            confirmButtonColor: "#FFA386"
        });
    });
});

// Register dialog for backward compatibility
dialogPolyfill.registerDialog(document.querySelector('#unavailable'));

// geolocation is downloaded if the popup has never been shown
let geoip = {};
fetch("https://geoip.maltertech.com")
    .then(response => response.json())
    .then(data => {
        // save geoip data
        geoip = data;

        // determine if we should show the not availiable popup
        if (!["US", "CA", "AU", "NZ"].includes(geoip.country_code) && localStorage.getItem("maltertech_not_available") === null) {
            localStorage.setItem("maltertech_not_available", "true");
            openNotAvailable();
        }

        // check for auto redirect
        if (localStorage.getItem("maltertech_auto_redirect") === null) {
            // check for domain mix match
            let matrix = {
                "US": "burleighwagon.com",
                "CA": "burleighwagon.com",
                "AU": "burleighwagon.com.au",
                "NZ": "burleighwagon.com.au"
            }

            // if this country is in the matrix and there is a mix match
            if (matrix[geoip.country_code] && matrix[geoip.country_code] !== window.location.hostname) {
                // update domain and redirect
                localStorage.setItem("maltertech_auto_redirect", "true");
                window.location.href = `https://${matrix[geoip.country_code]}`;
            }
        }
    })

